import { createReducer, on } from '@ngrx/store';
import * as actions from '../actions';

export const businessViewLinkedAssetManagerFeatureKey = 'businessViewLinkedAssetManager';

export interface BusinessViewLinkedAssetManagerState {
  loadBusinessViewLinkedAssetManagerResponse: any;
}

export const initialState: BusinessViewLinkedAssetManagerState = {
  loadBusinessViewLinkedAssetManagerResponse: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadBusinessViewLinkedAssetManagersSuccess, (state, action) => ({
    ...state,
    loadBusinessViewLinkedAssetManagerResponse: action.response
  }))
);

export const getBusinessViewLinkedAssetManagerList = (state: BusinessViewLinkedAssetManagerState) => {
  let parse;

  if (state.loadBusinessViewLinkedAssetManagerResponse !== undefined) {
    const stringify = JSON.stringify(state.loadBusinessViewLinkedAssetManagerResponse);
    parse = JSON.parse(stringify);
  }
  return parse;
};
